import SuccessToasts from './SuccessToasts';

export default SuccessToasts;
